<template>
  <b-card-code v-if="$checkPermission($options.name, 'view')"  id="api-notifications" no-body>

    <b-table
        striped
        hover
        responsive
        class="position-relative"
        :items="items"
        :fields="fields"
    >
      <template #cell(ValidDate)="data">
        {{data.value | formatDate}}
      </template>

      <template #cell(createdAt)="data">
        {{data.value | formatDate}}
      </template>

      <template #cell(status)="data">
        <fa-icon  icon="check"
                 :class="'table-action-icon item-status status-' + data.item.status"/>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

      <!-- page length -->
      <b-form-group
          :label="'Գտնվել է ' + pagination.total + ' տող'"
          label-cols="3"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            @input="getNotifications"
            v-model="pagination.current_page"
            :total-rows="pagination.total"
            :per-page="pagination.count"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import moduleApi from '@/store/api/moduleApi'
import {
  BAvatar,
  BBadge,
  BButton,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BRow,
  BTable
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'

export default {
  name: 'api-notifications',
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BForm,
    BRow,
    BCol,
    vSelect
  },
  data() {
    return {
      API_STORE_MODULE_NAME: 'apiModule',
      perPage: 20,
      pageOptions: [this.perPage],
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'email',
          label: 'Էլ․ փոստ',
        },
        {
          key: 'CarRegNo',
          label: 'Հաշվառման համարանիշ '
        },
        {
          key: 'createdAt',
          label: 'Բաժանորդագրվել է'
        },
        {
          key: 'ValidDate',
          label: 'Ակտիվ է մինչև',
        },
        {
          key: 'status',
          label: 'Կարգավիճակ'
        }
      ],
      addForm: false,
      editForm: false,
      formFields: {
        name: '',
        county: ''
      },
      form: {},
      filters: {
        region: null,
        county: null,
        name: ''
      }
    }
  },
  computed: {

    items() {
      return this.$store.state[this.API_STORE_MODULE_NAME].notifications
    },

    pagination() {
      return this.$store.state[this.API_STORE_MODULE_NAME].pagination
    },

    totalRows() {
      return this.items.length
    },
  },
  mounted() {
    // Set the initial number of items

  },
  async created() {
    if (!store.hasModule(this.API_STORE_MODULE_NAME)) store.registerModule(this.API_STORE_MODULE_NAME, moduleApi)
    this.getNotifications()
  },
  methods: {
    getNotifications() {
      const filterData = {
        ...this.filters,
        current_page: this.pagination.current_page
      }
      this.$vs.loading()
      this.$store.dispatch(`${this.API_STORE_MODULE_NAME}/getNotifications`, this.serialize(filterData))
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$root.$emit('getError', error)
          })
    },
    serialize(obj) {
      let str = []
      for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
          if (typeof obj[p] !== 'undefined' && obj[p] !== null && obj[p] !== '') {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
          }
        }
      }
      return str.join('&')
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#api-notifications {
  .table-responsive {
    max-height: calc(var(--vh, 1vh) * 100 - 15rem);
    min-height: calc(var(--vh, 1vh) * 100 - 15rem);
  }
}
</style>

